import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const ButtonsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(var(--oc-columns-number), calc(var(--oc-best-odds-width) * 1px));
  grid-column-gap: 4px;
  align-items: center;
  justify-content: space-around;
  grid-area: best-odds-buttons;
  margin: 8px 0px;

  @media (min-width: 768px) {
    grid-column-gap: 8px;
  }
`;

export const MarketBetWrapper = styled.span`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: auto;

  @media (min-width: 768px) {
    gap: 8px;
  }
`;

export const selectedBet = css``;

export const bestOddsButton = css`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(var(--oc-best-odds-width) * 1px);
  height: calc(var(--oc-best-odds-height) * 1px);
  min-height: calc(var(--oc-best-odds-height) * 1px);
  margin: 0;
  padding: 0;
  gap: 2px;
  border: var(--mc-button-border, none);
  border-radius: var(--mc-button-border-radius, 3px);
  font-family: var(--oc-font-family);
  box-shadow: none;
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  text-indent: 0;
  color: var(--ogm-text-body);
  background: var(--mc-button-background, #f2f5f6);
  transition: background-color 1s ease-out;
  cursor: pointer;
  transform: translateY(-1px);
  overflow: hidden;

  &:hover {
    background: var(--mc-button-background-hover, #00e889);
  }

  &.${selectedBet} {
    background-color: var(--mc-button-selected-background, #00e889);
    color: var(--mc-button-selected-text, var(--oc-primary-white));
  }
`;

export const ButtonTextWrapper = styled.span`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const LineWrapper = styled.span<{ useOddsFont?: boolean }>`
  font-size: var(--cxy-fontSize-s);
  line-height: 14px;
  font-weight: var(--cxy-fontWeight-bold);
  color: var(--ogm-timberwolves);
`;

export const OddsTextWrapper = styled.span<{ useLineFont?: boolean }>`
  margin-top: ${({ useLineFont }) => (useLineFont ? '-3px' : '0px')};
  font-size: var(--cxy-fontSize-s);
  line-height: 14px;
  font-weight: ${({ useLineFont }) => (useLineFont ? 'var(--cxy-fontWeight-semiBold)' : 'var(--cxy-fontWeight-bold)')};
  color: ${({ useLineFont }) => (useLineFont ? 'var(--ogm-pelicans-rebrand)' : 'var(--ogm-timberwolves)')};
`;

export const Empty = styled.div`
  width: calc(var(--oc-best-odds-width) * 1px);
  height: calc(var(--oc-best-odds-height) * 1px);
  position: relative;
  display: grid;
  place-items: center;
  margin: 0;
  padding: 0;
`;

// Hardcoded defaultFlashOptions values to avoid runtime imports in Linaria
const initialOpacity = 0.4;
const opacityCssVar = '--oc-background-opacity';

export const oddsColorClass = `
  ${opacityCssVar}: ${initialOpacity};
  --oc-cell-rgb: var(--oc-primary-white);
  background: rgba(var(--oc-cell-rgb), var(${opacityCssVar}));
  box-shadow: 0 2px 0 0 rgba(var(--oc-cell-rgb), 0.8);

  &:hover {
    box-shadow: 0 3px 2px 0 rgba(var(--oc-cell-rgb), 0.8);
  }
`;

export const oddDrifting = css`
  ${oddsColorClass}
  --oc-cell-rgb: var(--oc-odds-drifting-rgb);
`;

export const oddShortening = css`
  ${oddsColorClass}
  --oc-cell-rgb: var(--oc-odds-shortening-rgb);
`;

export const oddStable = css`
  background: var(--mc-button-background, #f2f5f6);
  box-shadow: 0 2px 0 0 var(--oc-box-shadow);

  &:hover {
    box-shadow: 0 3px 2px 0 #d0cfcf;
  }
`;
